import icon  from  '@material-ui/icons/StrikethroughS';
//import create from './SamplesCreate';   // this is the original routine to create by system parameter but temporly disable to allow manual additions
import list from './SamplesList';
import edit from './ExtraEdit'
import show from './SamplesView';




export default{ 
    //create,
    list,
    show, 
    edit,
    icon
};